<!-- HEADER -->
<app-fs-header (closeModalHandler)="closeModal()"></app-fs-header>
<app-fs-toolbar
  [activeNode]="activeNode"
  [selectedNodes]="selectedNodes"
  [activeToolbarAction]="activeToolbarAction"
  [moveFiletoggle]="moveFiletoggle"
  (iconActionHandler)="iconActionHandler($event)"
  (uploadHandler)="upload($event)"
></app-fs-toolbar>

<!-- BODY -->
<app-fs-splitter class="modal-body p-0">
  <div leftPanelContent class="bg-light pt-3 px-3 h-100">
    <app-fs-tree [nodes]="nodes" (nodesHandler)="nodesHandler($event)" (dropHandler)="onDropHandler($event)"></app-fs-tree>
  </div>
  <div rightPanelContent class="pt-3 px-3 h-100 d-flex flex-column gap-1">
    <div #navigationContainer class="d-flex gap-2">
      <div #navContainer class="form-control flex-1 fe-breadcrumb d-flex align-items-center">
        <app-fs-breadcrumb
          [node]="activeNode"
          [navContainer]="navContainer"
          [navigationContainer]="navigationContainer"
          [search]="searchContainer"
          (breadcrumbHandler)="breadcrumbHandler($event)"
        ></app-fs-breadcrumb>
      </div>
      <div #searchContainer>
        <app-fs-search
          [nodes]="nodes"
          [activeNodes]="activeNodes"
          [resetSearchNodes]="resetSearchNodes"
          [folderElement]="folderElement"
          (activeNodesHandler)="activeNodesHandler($event)"
          (folderElementHandler)="folderElementHandler($event)"
        ></app-fs-search>
      </div>
    </div>
    <div class="d-flex flex-wrap flex-1 align-content-start flex-wrap-animation nodes-container" appDropZone (fileDropped)="onDrop($event)">
      <div
        appDropZone
        #listItem
        *ngFor="let node of activeNodes; let i = index"
        [id]="node.id"
        class="no-select d-flex flex-column align-items-center p-2 fe-node-items"
        [ngClass]="selectedNodes.includes(node) ? 'selected-bg' : 'default-bg'"
        [draggable]="node.type === 'file'"
        (dragstart)="onDragStart($event, node)"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event, node, listItem)"
        (fileDropped)="onDrop($event)"
        (dblclick)="setActive(node)"
        (click)="handleItemClick($event, i, node)"
      >
        <ng-container *ngFor="let item of itemsIcon">
          <mat-icon [class]="item.class" placement="top" *ngIf="node.type === item.type && node.ext === item.ext">{{
            item ? item.icon : 'description'
          }}</mat-icon>
        </ng-container>
        <div class="node-title">
          {{ node.name }} <span class="mx-1" *ngIf="node.version">(v.{{ node.version }})</span>
        </div>
      </div>
    </div>
  </div>
</app-fs-splitter>

<!-- FOOTER -->
<div>
  <app-fs-footer
    [folderElement]="folderElement"
    [activeNode]="activeNode"
    [selectedNode]="selectedNode"
    [moveFiletoggle]="moveFiletoggle"
    (moveHandler)="moveHandler($event)"
    (moveFiletoggleHandler)="moveFiletoggleHandler($event)"
    (createNewFolder)="openModalNewFolder()"
  ></app-fs-footer>
</div>
